import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

function normalizeDev(msgObj) {
  let dev = msgObj?.dev;

  // if it's a JSON string like "[]", parse it
  if (typeof dev === "string") {
    try {
      dev = JSON.parse(dev);
    } catch {
      dev = [];
    }
  }

  // ensure it's an array
  if (!Array.isArray(dev)) dev = [];

  return { ...msgObj, dev: dev };
}

const BtTableList = ({
    serial,
    data,
    mqttReq
}) => {
    const [btListState, setBtListState] = useState({ "dev": [] });

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setBtListState(normalizeDev(data))
    }, [data]);

    function refreshbtlist() {
        mqttReq(serial, '/btmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'blue', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi BT' : 'Mostra BT'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_device" colSpan="5">BT devices</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                                {btListState?.time}
                            </th>
                        </tr>
                        <tr>
                            <th className="title">eui</th>
                            <th className="title">type</th>
                            <th className="title">name</th>
                            <th className="title">online</th>
                            <th className="title">config %</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={refreshbtlist}>aggiorna</button>
                            </th>
                        </tr>
                        {btListState?.dev.map(mapBTdev => (
                            <tr key={mapBTdev.eui}>
                                <td>{mapBTdev.eui}</td>
                                <td>{mapBTdev.type}</td>
                                <td>{mapBTdev.name}</td>
                                <td>{mapBTdev.online}</td>
                                <td>{mapBTdev.configPct}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default BtTableList;
